import axios from 'axios';

export function acceptRegistrationInvite(params) {
  const {token, password, name, lastName} = params;

  return axios.post(`/registration-invites/${token}/accept`, {password, name, lastName});
}
